"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _ContentProtectionToken = _interopRequireDefault(require("./ContentProtectionToken"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The DownloadFileInfo model module.
 * @module model/DownloadFileInfo
 * @version 1.1.3-alpha.1
 */
class DownloadFileInfo {
  /**
   * Constructs a new <code>DownloadFileInfo</code>.
   * @alias module:model/DownloadFileInfo
   */
  constructor() {
    DownloadFileInfo.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>DownloadFileInfo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DownloadFileInfo} obj Optional instance to populate.
   * @return {module:model/DownloadFileInfo} The populated <code>DownloadFileInfo</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new DownloadFileInfo();
      if (data.hasOwnProperty('token')) {
        obj['token'] = _ContentProtectionToken.default.constructFromObject(data['token']);
      }
      if (data.hasOwnProperty('fileName')) {
        obj['fileName'] = _ApiClient.default.convertToType(data['fileName'], 'String');
      }
      if (data.hasOwnProperty('mimeType')) {
        obj['mimeType'] = _ApiClient.default.convertToType(data['mimeType'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>DownloadFileInfo</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>DownloadFileInfo</code>.
   */
  static validateJSON(data) {
    // validate the optional field `token`
    if (data['token']) {
      // data not null
      _ContentProtectionToken.default.validateJSON(data['token']);
    }
    // ensure the json data is a string
    if (data['fileName'] && !(typeof data['fileName'] === 'string' || data['fileName'] instanceof String)) {
      throw new Error("Expected the field `fileName` to be a primitive type in the JSON string but got " + data['fileName']);
    }
    // ensure the json data is a string
    if (data['mimeType'] && !(typeof data['mimeType'] === 'string' || data['mimeType'] instanceof String)) {
      throw new Error("Expected the field `mimeType` to be a primitive type in the JSON string but got " + data['mimeType']);
    }
    return true;
  }
}

/**
 * @member {module:model/ContentProtectionToken} token
 */
DownloadFileInfo.prototype['token'] = undefined;

/**
 * @member {String} fileName
 */
DownloadFileInfo.prototype['fileName'] = undefined;

/**
 * @member {String} mimeType
 */
DownloadFileInfo.prototype['mimeType'] = undefined;
var _default = exports.default = DownloadFileInfo;